import {Error} from './error.class';
/**
 * Created by Rodrigo Quesada on 13/01/17.
 */
export class IllegalArgumentError extends Error {
    constructor(value: string) {
        super(value);
    }
}

export class IllegalStateError extends Error {
    constructor(value: string) {
        super(value);
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/common/error/common-errors.class.ts